import type {
	CompanyDetail,
	CompanyMutations,
	CompanyShared,
	CompanyTranslations,
} from "Infrastructure/Translation/Types/company";

const companySharedTranslations: CompanyShared = {
	actions: "Actions",
	addNewCompany: "Add company",
	editCompany: "Edit company",
	save: "Save",
	heading: "Companies",
};

const companyDetailTranslations: CompanyDetail = {
	pageTitle: "Detail company",
	pageDescription: "Detailed information about company",
	info: {
		id: "ID",
		name: "Name",
		email: "Email",
		phone: "Phone",
		country: "Country",
		city: "City",
		street: "Street",
		buildingNumber: "Building number",
		postCode: "Post code",
		businessId: "Business ID",
		vatId: "VAT ID",
		iban: "IBAN",
		bankName: "Bank name",
		bankAccount: "Bank account",
		dateCreated: "Date created",
		invoiceDueDays: "Invoice due days",
	},
};

const companyMutations: CompanyMutations = {
	companyCreateSuccess: "Company created successfully",
	companyCreateError: "Error while creating company",
	companyUpdateSuccess: "Company updated successfully",
	companyUpdateError: "Error while updating company",
};

const companyTranslations: CompanyTranslations = {
	detail: companyDetailTranslations,
	shared: companySharedTranslations,
	mutations: companyMutations,
};

export default companyTranslations;
